import { render, staticRenderFns } from "./MsiSpinner.vue?vue&type=template&id=0a73ff61&scoped=true&functional=true&"
import script from "./MsiSpinner.vue?vue&type=script&lang=js&"
export * from "./MsiSpinner.vue?vue&type=script&lang=js&"
import style0 from "./MsiSpinner.vue?vue&type=style&index=0&id=0a73ff61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0a73ff61",
  null
  
)

export default component.exports